export { default } from './BetaTag';
